import React from 'react';
import '../css/whyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/>
          <path d="M12 22V12"/>
          <path d="M2 7l10 5 10-5"/>
          <path d="M7 9.5l5 2.5 5-2.5"/>
        </svg>
      ),
      title: '20+ Years Experience',
      description: 'Two decades of expertise in industrial valve manufacturing with proven track record.'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      ),
      title: 'ISO 9001 Certified',
      description: 'Internationally recognized quality management system ensuring consistent excellence.'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <path d="M7 8h10M7 12h10M7 16h4"/>
        </svg>
      ),
      title: 'Make in India',
      description: 'Proudly Indian manufacturer supporting local economy and global standards.'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      ),
      title: 'Precision Engineering',
      description: 'Advanced manufacturing processes delivering valves with unmatched accuracy.'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2v20M2 12h20"/>
        </svg>
      ),
      title: 'Global Standards',
      description: 'Compliance with ASME, API, and ISO standards for worldwide acceptance.'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 11l3 3L22 4"/>
          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
        </svg>
      ),
      title: 'Quality Assurance',
      description: 'Rigorous testing and quality control at every stage of production.'
    }
  ];

  return (
    <section id="why-choose" className="why-choose-us">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Why Choose Us</span>
          <h2 className="section-title">
            Excellence in Every Detail
          </h2>
          <p className="section-subtitle">
            Experience unmatched quality, reliability, and expertise that sets us apart in industrial valve manufacturing
          </p>
        </div>

        <div className="reasons-flow">
          {reasons.map((reason, index) => (
            <div 
              key={index} 
              className="reason-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {index < reasons.length - 1 && (
                <div className="flow-connector"></div>
              )}
              <div className="reason-icon-wrapper">
                <div className="icon-bg"></div>
                <div className="icon-inner">
                  {reason.icon}
                </div>
              </div>
              <div className="reason-text">
                <h3 className="reason-title">{reason.title}</h3>
                <p className="reason-description">{reason.description}</p>
              </div>
              <div className="reason-number">
                <span>0{index + 1}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
